import type { ExamFormTest } from "@rmh/defs";
import { TestType } from "../types/examForms";

type TestValue = keyof typeof TestType;

export const getSubtype = (item: ExamFormTest): TestValue => {
  if (item.__typename === "ExamFormTestTable") {
    return item.examFormTableType as TestValue;
  }

  if (item.__typename === "ExamFormTestChoice") {
    return item.examFormChoiceType as TestValue;
  }

  if (item.__typename === "ExamFormTestData") {
    return item.examFormDataInputType as TestValue;
  }

  return TestType.ExamFormRLTable;
};

export const getOptionsFromTitle = (
  title: string,
  id: string
): Record<string, string>[] =>
  title
    .split(";")
    .splice(1, title.length)
    .map((word) => ({
      key: `option_${id}_${word.trim()}`,
      value: word.trim(),
      label: word.trim(),
    }));
